module.exports = __webpack_public_path__ + "static/media/4.question_loop.05462047.mp4";